
export const getOS = function() {
  return JSON.parse(window.localStorage.getItem('os'));
};
export const setOS = function(val) {
  if (typeof val !== 'string') val = JSON.stringify(val);
  window.localStorage.setItem('os', val);
};
export const removeOS = function(){
  window.localStorage.removeItem('os')
}

export const getUser = function() {
  return JSON.parse(window.localStorage.getItem('user'));
};
export const setUser = function(val) {
  if (typeof val !== 'string') val = JSON.stringify(val);
  window.localStorage.setItem('user', val);
};
export const removeUser = function(){
  window.localStorage.removeItem('user')
}

export const getChannels = function() {
  return JSON.parse(window.localStorage.getItem('channels'));
};
export const setChannels = function(val) {
  if (typeof val !== 'string') val = JSON.stringify(val);
  window.localStorage.setItem('channels', val);
};
export const removeChannels = function(){
  window.localStorage.removeItem('channels')
}

export const getFollowingChs = function() {
  return JSON.parse(window.localStorage.getItem('followingChs'));
};
export const setFollowingChs = function(val) {
  if (typeof val !== 'string') val = JSON.stringify(val);
  window.localStorage.setItem('followingChs', val);
};
export const removeFollowingChs = function(){
  window.localStorage.removeItem('followingChs')
}
